import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		title: {
			fontSize: theme.typography.h3.fontSize,
			fontWeight: theme.typography.h3.fontWeight,
			fontFamily: theme.typography.fontFamily,
			color: theme.palette.custom.textPrimary,
		},
		newButtonAction: {
			marginTop: 0,
		},
		newButtonTitle: {
			color: theme.palette.primary.contrastText,
		},
		buttonRoot: {
			display: "inline-block",
			padding: "0px 8px",
			minHeight: 0,
			minWidth: 0,
		},
		cardActions: {
			justifyContent: "center",
		}
	} satisfies Record<string, CSSObject>;
};
